// extracted by mini-css-extract-plugin
module.exports = {"root":"logo_root__aMoyv","text":"logo_text__yoUBb","image":"logo_image__GPj7E"};